import type { CustomTargetingParams } from '@openx/types/targeting/advancedTargeting.ts';
import type { CustomVariablesDataPayload } from '@openx/types/targeting/customVariables.ts';

/** Builds the Custom Targeting card value from the two form fields it shows. */
export const toCustomTargetingParams = (
  customVariables: Pick<CustomTargetingParams, 'custom' | 'op'> | null | undefined,
  contextual: CustomVariablesDataPayload[] | null | undefined
): CustomTargetingParams => ({
  custom: customVariables?.custom?.length ? customVariables.custom : null,
  op: customVariables?.op,
  contextual: contextual ?? [],
});
